document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const splitLineElements = gsap.utils.toArray("h2");

  splitLineElements.forEach(element => {
    const tl = gsap.timeline({ paused: true });

    const split = new SplitText(element, {
      type: "lines, words",
      linesClass: "line"
    });

    // Imposta overflow hidden sulle righe
    split.lines.forEach(line => {
      line.style.overflow = "hidden";
      line.style.display = "block";
      line.style.position = "relative";
    });


     // funzione per gradiente unico per gli span sottolineati
    function alignGradientForSpan(spanEl) {
      const spanRect = spanEl.getBoundingClientRect();
      // prendi solo le "words" che stanno dentro questo span
      const wordsInSpan = split.words.filter(w => spanEl.contains(w));

      wordsInSpan.forEach(word => {
        const r = word.getBoundingClientRect();
        const dx = r.left - spanRect.left; // offset della parola nello span

        // stile per il gradiente “unico”
        word.style.backgroundImage = "linear-gradient(45deg,#004F7F,#208FD4,#C363E9)";
        word.style.backgroundRepeat = "no-repeat";
        word.style.backgroundSize = spanRect.width + "px 100%";
        word.style.backgroundPosition = `-${dx}px 0`;
        word.style.webkitBackgroundClip = "text";
        word.style.backgroundClip = "text";
        word.style.webkitTextFillColor = "transparent";
        word.style.color = "transparent";
      });
    }

    function alignAllGradients() {
      // tutti gli span con underline dentro questo h2
      const underlinedSpans = element.querySelectorAll('span[style*="text-decoration:underline"]');
      underlinedSpans.forEach(alignGradientForSpan);
    }

    // allinea quando i font sono pronti e al resize
    if (document.fonts?.ready) {
      document.fonts.ready.then(alignAllGradients);
    } else {
      window.addEventListener("load", alignAllGradients, { once: true });
    }
    window.addEventListener("resize", alignAllGradients);


    // Anima le parole (che sono dentro le righe)
    tl.from(split.words, {
      y:200,
      opacity: 1,
      duration: 1,
      ease: "power3.out",
      stagger: 0.06
    });

    ScrollTrigger.create({
      trigger: element,
      start: "top 85%",
      onEnter: () => tl.play()
    });
  });
});

// --- PARALLAX colonna destra (solo desktop) ---
(function initParallaxRightColumnGlobal() {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  var mm = gsap.matchMedia();

  function setupForAllSections() {
    // Sezioni abilitate (accetta qualunque valore dell'attributo)
    var sections = gsap.utils.toArray('[data-parallax-right]');

    sections.forEach(function(sectionEl) {
      // Evita doppie inizializzazioni
      if (sectionEl._parallaxInit) return;
      sectionEl._parallaxInit = true;

      mm.add("(min-width: 992px)", function() {
        // Trova la griglia (supporta due markup)
        var list =
          sectionEl.querySelector('.multicolumn-bg__list') ||
          sectionEl.querySelector('.banner-grid__grid');

        if (!list) return;

        // Trova le card (supporta due classi)
        var cards = list.querySelectorAll('.multicolumn-bg__card, .banner-grid__card');
        if (cards.length < 2) return;

        var right = cards[1]; // colonna destra

        // Parametri dai data-attr con default
        var offset = Number(sectionEl.dataset.parallaxOffset || 300);
        var speed  = Number(sectionEl.dataset.parallaxSpeed  || 1.15);

        // Offset iniziale: abbassa la 2ª card
        right.style.marginTop = offset + 'px';
        right.style.willChange = 'transform';

        // Calcola il delta extra (più veloce della sinistra)
        function extraY() {
          var range = sectionEl.offsetHeight - window.innerHeight;
          if (range < 0) range = 0;
          return -range * (speed - 1);
        }

        // Se esiste un tween precedente, kill
        if (right._parallaxTween && right._parallaxTween.scrollTrigger) {
          right._parallaxTween.scrollTrigger.kill();
          right._parallaxTween.kill();
        }

        // nuova versione
function scrollDistance() {
  // distanza di trigger: da "top bottom" a "bottom top"
  return sectionEl.offsetHeight + window.innerHeight;
}
function deltaY() {
  // colonna destra un filo più veloce (usa il tuo "speed")
  return -scrollDistance() * (speed - 1);
}

// kill eventuale tween precedente
if (right._parallaxTween && right._parallaxTween.scrollTrigger) {
  right._parallaxTween.scrollTrigger.kill();
  right._parallaxTween.kill();
}

right._parallaxTween = gsap.to(right, {
  y: deltaY,               // funzione → ricalcola ai refresh
  ease: "none",
  scrollTrigger: {
    trigger: sectionEl,
    start: "top bottom",
    end: "bottom top",
    scrub: true,
    invalidateOnRefresh: true
  }
});

// ricalcola ai refresh/resize
ScrollTrigger.addEventListener("refreshInit", function () {
  if (right._parallaxTween) right._parallaxTween.invalidate();
});


        // Cleanup quando si esce dal breakpoint
        return function cleanup() {
          if (right._parallaxTween && right._parallaxTween.scrollTrigger) {
            right._parallaxTween.scrollTrigger.kill();
          }
          if (right._parallaxTween) right._parallaxTween.kill();
          right.style.transform = '';
          right.style.marginTop = '';
          right.style.willChange = '';
        };
      });
    });
  }

  // Inizializza
  setupForAllSections();

  //Shopify ricarica sezioni in editor / ajax
  document.addEventListener('shopify:section:load', setupForAllSections);
  document.addEventListener('shopify:section:reorder', setupForAllSections);
})();

